import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { QUOTE_INTRO_PATH } from 'services/conlicitaseg';

import * as S from './styles';

export const VIDEO_URL = '';

const ConlicitasegOnlyOnboarding: React.FC = () => {
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const email = profile?.email;

  return (
    <div className="page-container">
      <S.Container>
        {email && (
          <S.ValidationNotice role="status">
            {`Um e-mail foi enviado para ${email} para validação da conta.`}
          </S.ValidationNotice>
        )}
        <S.Content>
          <S.VideoPlaceholder>Video da ferramenta</S.VideoPlaceholder>
          <S.Title>
            Bem-vindo ao conlicitaSeg, a ferramenta de Seguros Garantia do Conlicitação.
          </S.Title>
          <S.Description>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor
            incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
            exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure
            dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
          </S.Description>
          <S.Description>
            Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt
            mollit anim id est laborum. Curabitur pretium tincidunt lacus. Nulla gravida orci a
            odio. Nullam varius, turpis et commodo pharetra, est eros bibendum elit, nec luctus
            magna felis sollicitudin mauris. Integer in mauris eu nibh euismod gravida.
          </S.Description>
          <S.Actions>
            <Link className="btn btn-primary" to={QUOTE_INTRO_PATH}>
              Fazer cotação
            </Link>
          </S.Actions>
        </S.Content>
      </S.Container>
    </div>
  );
};

export default ConlicitasegOnlyOnboarding;
